// Notification factories
import NotificationsRepositoriesFactory from '../Repositories/factory.js'
import NotificationsServicesFactory from '../Services/factory.js'
// Notifications use cases
import GetPendingPtaUseCase from './GetPendingPtaUseCase.js'
import GetUserProfileNotificationsUseCase from './GetUserProfileNotificationsUseCase.js'
import SendEmailValidationUseCase from './SendEmailValidationUseCase.js'
import SetUserProfileNotificationsUseCase from './SetUserProfileNotificationsUseCase.js'

/**
 * Factory methods for notifications service
 */
export default class NotificationsUsesCaseFactory {
  static getPendingPtaUseCase = ({config}) =>
    new GetPendingPtaUseCase({
      getPendingPtaService: NotificationsServicesFactory.getPendingPtaService({
        config
      })
    })

  static getUserProfileNotificationsUseCase = ({config}) =>
    new GetUserProfileNotificationsUseCase({
      repository: NotificationsRepositoriesFactory.cookieNotificationsRepository({
        config
      })
    })

  static setUserProfileNotificationsUseCase = ({config}) =>
    new SetUserProfileNotificationsUseCase({
      repository: NotificationsRepositoriesFactory.cookieNotificationsRepository({
        config
      })
    })

  static sendEmailValidationUseCase = ({config}) =>
    new SendEmailValidationUseCase({
      service: NotificationsServicesFactory.sendEmailNotificationsService({
        config
      })
    })
}
